
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.219 3L15 3.688 10.187 19H7.25l-2.219 7.719L5 29h22v-2l-2.25-8h-2.938L16.97 3.687 16.75 3zm-.313 7.781c.332.13.715.219 1.094.219.379 0 .762-.09 1.094-.219l1.156 3.688c-.555.289-1.277.531-2.25.531-.969 0-1.695-.238-2.25-.531zM12.25 19.22c.758.34 2.004.781 3.75.781s2.992-.441 3.75-.781l1.094 3.437c-.117.117-.117.196-.625.469-.785.422-2.098.875-4.219.875-2.121 0-3.434-.453-4.219-.875-.508-.273-.508-.352-.625-.469z"}})])
          )
        }
      }
    